import type { ReactNode } from 'react';

import { ThemeProvider } from './ThemeContext';
import { LaunchProvider } from './LaunchContext';
import { SessionProvider } from './SessionContext';
import { StaffDirectoryProvider } from './StaffContext';
import { ServiceCatalogProvider } from './ServiceContext';
import { AttendanceProvider } from './AttendanceContext';
import { VisitorProvider } from './VisitorContext';

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider>
      <LaunchProvider>
        <SessionProvider>
          <StaffDirectoryProvider>
            <ServiceCatalogProvider>
              <AttendanceProvider>
                <VisitorProvider>{children}</VisitorProvider>
              </AttendanceProvider>
            </ServiceCatalogProvider>
          </StaffDirectoryProvider>
        </SessionProvider>
      </LaunchProvider>
    </ThemeProvider>
  );
}
